import { useCallback, useEffect, useState } from 'react';
import { marketplaceService } from '../services/marketplaceService';
import type { MicrosoftLicenceReference } from './microsoftLicencePricing';

export interface MicrosoftLicenceReferenceState {
  reference: MicrosoftLicenceReference | null;
  error: string | null;
  reload: () => void;
}

/** The built-in Microsoft licence reference from the marketplace function. */
export function useMicrosoftLicenceReference(): MicrosoftLicenceReferenceState {
  const [reference, setReference] = useState<MicrosoftLicenceReference | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setError(null);
    marketplaceService.getMicrosoftLicenceReference()
      .then((loaded) => {
        if (!cancelled) setReference(loaded);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err.message : "Couldn't load Microsoft's licence list");
      });
    return () => {
      cancelled = true;
    };
  }, [attempt]);

  const reload = useCallback(() => setAttempt((value) => value + 1), []);
  return { reference, error, reload };
}
